module.exports = __webpack_public_path__ + "static/CathleenSun-13c65c921b0202e1fda2c4ae29a917b8.jpeg";